<template>
  <!-- z-[60] keeps toasts above the Modal overlay (z-50); top-20 clears the navbar.
       aria-atomic=false: role=status implies atomic, which would re-announce the
       whole stack every time a toast is added or dismissed -->
  <div
    class="fixed top-20 right-4 z-[60] flex flex-col gap-2 w-80 max-w-[calc(100vw-2rem)] pointer-events-none"
    aria-live="polite"
    aria-atomic="false"
  >
    <TransitionGroup name="toast">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="flex items-start gap-3 px-4 py-3 bg-white dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700 rounded-xl shadow-large pointer-events-auto"
      >
        <span
          class="material-icons text-[20px] flex-shrink-0"
          :class="iconClasses[toast.type]"
          aria-hidden="true"
        >{{ icons[toast.type] }}</span>
        <p class="flex-1 text-sm text-neutral-900 dark:text-neutral-100">{{ toast.message }}</p>
        <button
          type="button"
          @click="dismissToast(toast.id)"
          aria-label="Dismiss notification"
          class="flex-shrink-0 p-0.5 rounded text-neutral-400 hover:text-neutral-600 dark:hover:text-neutral-300 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
        >
          <span class="material-icons text-[18px]" aria-hidden="true">close</span>
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
import useToast from "@/composables/useToast";

export default {
  name: "ToastHost",
  setup() {
    const { toasts, dismissToast } = useToast();

    const icons = {
      success: "check_circle",
      error: "error",
      info: "info",
    };

    const iconClasses = {
      success: "text-green-600",
      error: "text-red-600",
      info: "text-secondary-600",
    };

    return { toasts, dismissToast, icons, iconClasses };
  },
};
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(16px);
}
.toast-move {
  transition: transform 0.2s ease;
}

@media (prefers-reduced-motion: reduce) {
  .toast-enter-active,
  .toast-leave-active,
  .toast-move {
    transition: none;
  }
}
</style>
